import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPlayCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.6807 7.4734L1.95742 0.0824381C1.53173 -0.151817 1 0.141097 1 0.609229V15.3908C1 15.8589 1.53173 16.1518 1.95742 15.9176L14.6807 8.5266C15.1064 8.29235 15.1064 7.70728 14.6807 7.47302V7.4734Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgPlayCircle)
const IconSvgPlayCircle = createIcon(ForwardRef, 'SvgPlayCircle')
export default IconSvgPlayCircle
